module.exports = __webpack_public_path__ + "peter.png";